import { render, staticRenderFns } from "./Section13.vue?vue&type=template&id=0235b332&"
import script from "./Section13.vue?vue&type=script&lang=js&"
export * from "./Section13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports